import React from 'react'
import {StudentInput} from '../StudentInput/StudentInput'
import StudentStatusInformationPopup from './StudentStatusInformationPopup/StudentStatusInformationPopup'
import InvoicePreviewPopup from '../StudentModal2022/InvoicePreviewPopup/InvoicePreviewPopup'
import useFetch from '../hooks/useFetch'
import { baseUrl } from '../assets/Animations'
import './student-modal.css'
import axios from 'axios'
import AutoPaySwitch from '../StudentModal2022/StudentModalSwitches/AutoPaySwitch'
import MoreAttentionSwitch from '../StudentModal2022/StudentModalSwitches/MoreAttentionSwitch'
import { min, parseISO } from 'date-fns'

const myToken = localStorage.getItem('token')
const myHeader = {headers: { Authorization: `Bearer ${myToken}` }}

const StudentModal = (props) => {
    const [popup, setPopup] = React.useState(false)
    const [totalLessons, setTotalLessons] = React.useState(0)
    const [revenue, setRevenue] = React.useState(0)
    const [cancellations, setCancellations] = React.useState(0)
    const [teacherCancelled, setTeacherCancelled] = React.useState(0)
    const [firstLessonReceived, setFirstLessonReceived] = React.useState('loading...')
    const [lessThan24, setLessThan24] = React.useState(0)
    const [invoicePopup, setInvoicePopup] = React.useState(false)
    const {data: invoices} = useFetch(`${baseUrl}/invoicesfam/${props.family.waveCustomerId}`)
    const {data: timesheets} = useFetch(`${baseUrl}/family-timesheet-cancellations/${props.family.familyId}`)

    React.useEffect(() => {
        openingAnimation()
    }, [])

    React.useEffect(() => {
        processInvoices()
    }, [invoices])

    React.useEffect(() => {
        for(let i = 0; i < timesheets.length; i++) {
            for(let j = 0; j <timesheets[i].families.length; j++) {
                if(timesheets[i].families[j].id === props.family.familyId) {
                    for(let k = 0; k < timesheets[i].families[j].cancellations.length; k++) {
                        if(timesheets[i].families[j].cancellations[k].cancellor === 'student') {
                            setCancellations(prev => (prev + 1))
                        }
                        if(timesheets[i].families[j].cancellations[k].cancellor === 'teacher') {
                            setTeacherCancelled(prev => (prev + 1))
                        }
                        if (timesheets[i].families[j].cancellations[k].cancellor === 'student less than 24hrs') {
                            setLessThan24(prev => (prev + 1))
                        }
                    }
                }
            }
        }
    }, [timesheets])

    const openingAnimation = () => {
        document.getElementById('student-modal-content').style.opacity = 1
        document.getElementById('student-modal-content').style.transform = 'scale(1)'
    }
    const closingAnimation = () => {
        document.getElementById('student-modal-content').style.opacity = 0
        document.getElementById('student-modal-content').style.transform = 'scale(0.5)'
    }

    const closeByClickingOff = (tar) => {
        if(tar === "student-modal-wrapper" || tar === "student-modal-the-x") {
            closingAnimation()
            setTimeout(() => {
                props.closeStudentModal("student-modal-wrapper")
            }, 200)
        }
    }

    const processInvoices = () => {
        let tempLessonTotal = 0
        let tempRevenueTotal = 0
        for(let i = 0; i < invoices.length; i++) {
            for(let j = 0; j < invoices[i].lessonsToBeBilled.length; j++) {
                tempLessonTotal ++
                let myLessonLength = invoices[i].lessonsToBeBilled[j].lessonLength
                if(parseInt(myLessonLength) === 31 || parseInt(myLessonLength) === 46 || parseInt(myLessonLength) === 61) {
                    if(parseInt(myLessonLength) === 31) {
                      tempRevenueTotal = tempRevenueTotal + 25
                    } else if (parseInt(myLessonLength) === 46) {
                      tempRevenueTotal = tempRevenueTotal + 35
                    } else if (parseInt(myLessonLength) === 61) {
                      tempRevenueTotal = tempRevenueTotal + 45
                    }
                  } else {
                    if(invoices[i].lessonsToBeBilled[j].studentAllRates) {
                        tempRevenueTotal = tempRevenueTotal + invoices[i].lessonsToBeBilled[j].studentAllRates[myLessonLength]
                    }
                  }
            }
        }
        setTotalLessons(tempLessonTotal)
        setRevenue(tempRevenueTotal)
        setFirstLessonReceived(returnFirstLessonReceived(invoices))
    }

    const returnFirstLessonReceived = (invoices) => {
        if(invoices.length > 0) {
            const dates = invoices.reduce((acc, curr) => {
                const lessonDates = curr.lessonsToBeBilled.map(lesson => new Date(`${curr.year}-${curr.monthNumber}-${lesson.date}`));
                return [...acc, ...lessonDates];
              }, []);
              return min(dates).toDateString();
        } else {
            return 'No Lessons Yet'
        }
    }

    const changeFamilyStatusAndSendToSlack = (value) => {
        let message = `The *${props.family.familyName} Family* has been changed from *${props.family.familyStatus}* to *${value}*`
        axios.post(`${baseUrl}/atharo-slack/${props.family.school.toLowerCase()}`, {message: message}, myHeader)
        props.editStudentInfo("index-placeholder", "familyStatus", value, props.family.familyId)
    }

    let onboardDateString = new Date(props.family.onboardDate)
    return (
        <div className="student-modal-wrapper" id="student-modal-wrapper" onMouseDown={(e) => closeByClickingOff(e.target.id)}>
            <div className="student-modal-content" id="student-modal-content">
                {popup && <StudentStatusInformationPopup />}
                {invoicePopup && <InvoicePreviewPopup invoicePopup={invoicePopup} setInvoicePopup={setInvoicePopup} setInvoiceView={props.setInvoiceView} />}
                <div className="student-modal-x-wrapper">
                    <div id="student-modal-the-x" onClick={(e) => closeByClickingOff(e.target.id)} className="student-modal-the-x">x</div>
                </div>
                {/* <div className="student-modal-title">Edit Family Profile</div> */}
                <div className="student-modal-header">
                    {props.family.moreAttention && <img alt='millie' src='millie_bobby_brown_alert.jpg' className='millie-bobby-brown-alert' />}
                    <div className="student-modal-header-left">
                        <div className="student-modal-subtitle">{props.family.familyName} Information</div>
                        <div className="onboard-date">Form Submitted: <strong>{onboardDateString.toDateString()}</strong></div>
                        <div className="onboard-date">First Lesson: <strong>{firstLessonReceived}</strong></div>
                        <div className='student-modal__switch-wrapper'>
                            <AutoPaySwitch studentModal={props.family} editStudentInfo={props.editStudentInfo} />
                            <MoreAttentionSwitch studentModal={props.family} editStudentInfo={props.editStudentInfo} />
                        </div>
                    </div>
                    <div className="student-modal-header-right">
                        <div className="family-status-wrapper">
                            <div className="information-i" onMouseEnter={() => setPopup(true)} onMouseLeave={() => setPopup(false)} ></div>
                            <select className="family-status" id="status-filter" onChange={(e) => changeFamilyStatusAndSendToSlack(e.target.value)} value={props.family.familyStatus}>
                                <option value="---" default>Status</option>
                                <option value="Active" default>Active</option>
                                <option value="Being Onboarded">Being Onboarded</option>
                                {/* <option value="Prospective">Prospective</option> */}
                                <option value="Waitlist">Waitlist</option>
                                <option value="Taking a Break">Taking a Break</option>
                                <option value="Summer Break">Summer Break</option>
                                <option value="Scholarship">Scholarship</option>
                                <option value="Needs New Teacher">Needs New Teacher</option>
                                <option value="Left the School">Left the School</option>
                                <option value="Inquired">Inquired</option>
                            </select>
                        </div>
                        <div className="family-school-wrapper">
                            <select className="family-status" value={props.family.school} onChange={(e) => props.editStudentInfo("index-placeholder", "school", e.target.value, props.family.familyId)}>
                                <option value="ALL" default>Select a school</option>
                                <option value="MMA">Mountainside</option>
                                <option value="LSMA">Lakeside</option>
                                <option value="TMA">Treeside</option>
                                <option value="GLMA">Great Lakes</option>
                                <option value="MOR">Morningside</option>
                                <option value="PSMA">Parkside</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div className='family-stat-wrapper'>
                        <div className='student-modal__total-family-stat'>
                            <div className='total-family-stat__header'>Lessons Received:</div> 
                            <div className='total-family-stat__stat'>{totalLessons}</div> 
                        </div>
                        <div className='student-modal__total-family-stat family-stat__invoices-btn' onMouseEnter={() => setInvoicePopup(props.family.familyId)}>
                            <div className='total-family-stat__header'>Amount Paid:</div> 
                            <div className='total-family-stat__stat'>${revenue}</div>
                        </div>
                        <div className='student-modal__total-family-stat'>
                            <div className='total-family-stat__header'>Family Cancellations:</div> 
                            <div className='total-family-stat__stat'>{cancellations}</div>
                        </div>
                        <div className='student-modal__total-family-stat'>
                            <div className='total-family-stat__header'>Less Than 24hr Cancellation:</div> 
                            <div className='total-family-stat__stat'>{lessThan24}</div>
                        </div>
                        <div className='student-modal__total-family-stat'>
                            <div className='total-family-stat__header'>Teacher Cancellations:</div> 
                            <div className='total-family-stat__stat'>{teacherCancelled}</div>
                        </div>
                    </div>
                <div className="first-name-wrapper top-first-name-wrapper">
                    <div className="input-label">Family name</div>
                    <input className="student-modal-firstname" onChange={(e) => props.editStudentInfo("index-placeholder", "familyName", e.target.value, props.family.familyId)} value={props.family.familyName}/>
                </div>
                <div className="right-side-name-wrapper">
                    <div className="input-label">Parent/Guardian Name(s)</div>
                    <input className="student-modal-firstname" onChange={(e) => props.editStudentInfo("index-placeholder", "primaryParentName", e.target.value, props.family.familyId)} value={props.family.primaryParentName}/>
                </div>
                <div className="first-name-wrapper">
                    <div className="input-label">Email</div>
                    <input className="student-modal-firstname" onChange={(e) => props.editStudentInfo("index-placeholder", "primaryEmail", e.target.value, props.family.familyId)} value={props.family.primaryEmail}/>
                </div>
                <div className="first-name-wrapper phone-numbers-wrapper">
                    <div className="input-label student-modal-half-width-label">Cell #</div>
                    <div className="input-label student-modal-half-width-label">Home #</div>
                    <input className="student-modal-firstname student-modal-half-width" onChange={(e) => props.editStudentInfo("index-placeholder", "primaryCellphone", e.target.value, props.family.familyId)} value={props.family.primaryCellphone}/>
                    <input className="student-modal-firstname student-modal-half-width" onChange={(e) => props.editStudentInfo("index-placeholder", "primaryHomePhone", e.target.value, props.family.familyId)} value={props.family.primaryHomePhone}/>
                </div>
                <div className="right-side-address-wrapper">
                    <div className="right-side-address">
                        <div className="input-label">Street Address</div>
                        <input className="student-modal-address" onChange={(e) => props.editStudentInfo("index-placeholder", "addressLine1", e.target.value, props.family.familyId)} value={props.family.address.addressLine1}/>
                    </div>
                    <div className="triple-address-wrapper">
                        <div className="student-modal-right-side-city">
                            <div className="input-label address-label-third">City</div>
                            <input className="student-modal-address address-input-third" placeholder="City" onChange={(e) => props.editStudentInfo("index-placeholder", "city", e.target.value, props.family.familyId)} value={props.family.address.city}/>
                        </div>
                        <div className="student-modal-right-side-city">
                            <div className="input-label address-label-third">State</div>
                            <input className="student-modal-address address-input-third" placeholder="State" onChange={(e) => props.editStudentInfo("index-placeholder", "state", e.target.value, props.family.familyId)} value={props.family.address.state}/>
                        </div>
                        <div className="student-modal-right-side-city">
                            <div className="input-label address-label-third">Zip</div>
                            <input className="student-modal-address address-input-third" placeholder="Zip" onChange={(e) => props.editStudentInfo("index-placeholder", "zipcode", e.target.value, props.family.familyId)} value={props.family.address.zipcode}/>
                        </div>
                    </div>
                </div>
                <div className="right-side-notes">
                    <div className="input-label">Notes</div>
                    <textarea className="student-modal-notes" onChange={(e) => props.editStudentInfo("index-placeholder", "familyNotes", e.target.value, props.family.familyId)} value={props.family.familyNotes}/>
                </div>
                <div className="existing-student-modal-line"></div>
                {props.family.students.map((student, i) => (
                    <StudentInput key={student.studentId} FamilyId={props.family.familyId} family={props.family} theSchool={props.family.school} teachers={props.teachers} removeAStudent={props.removeAStudent} student={student} index={i} editStudentInfo={(theIndex, key, theChange, id) => props.editStudentInfo(theIndex, key, theChange, id)} setCurrentOpenStudents={props.setCurrentOpenStudents} currentOpenStudents={props.currentOpenStudents}  />
                    ))}
                <div className="add-a-student-btn" onClick={() => props.addAStudent()}>+ Add a student</div>
                {/* <div id="update-student-info" onClick={(e) => props.closeStudentModal(e.target.id)} className="student-modal-save-btn">Save</div> */}
                <div id="remove-family-btn" onClick={(e) => props.setAreYouSure(props.family.familyId)} className="remove-family-btn">Remove Family</div>
            </div>
        </div>
    )

}
export default StudentModal;